import React from 'react';
import Keycloak from 'keycloak-js';
import {APPLICATION, collectsRoles} from "./PermissionContext";

export interface IAuthContext {
    authenticated: boolean;
    token?: Keycloak.KeycloakInstance;
    //realm?: string;
    updateToken: (token:Keycloak.KeycloakInstance) => void;
    //updateRealm: (realm: string) => void;
    checked: boolean;
    updateChecked: () => void;
}

const defaultUpdateToken = (token: Keycloak.KeycloakInstance) => {};
const defaultUpdateRealm = (realm: string) => {};
const defaultUpdateChecked = () => {};

export const AuthContext =
    React.createContext<IAuthContext>({
        authenticated: false,
        //realm: undefined as (string | undefined),
        token: undefined as (Keycloak.KeycloakInstance | undefined),
        updateToken: defaultUpdateToken,
        checked: false,
        updateChecked: defaultUpdateChecked
        //updateRealm: defaultUpdateRealm
    });

export interface IAuthStore {
    token?: Keycloak.KeycloakInstance;
    //realm?: string;
   // updateToken: (token: Keycloak.KeycloakInstance) => void;
}

export const AuthStore: React.FC<IAuthStore> = (props) => {
    const [token, setToken] = React.useState(props.token);
    const [checked, setChecked] = React.useState(false);
    //const [realm, setRealm] = React.useState(props.realm);
    const [authenticated, setAuthenticated] =
        React.useState((props.token !== undefined ? props.token.authenticated : undefined));

    const updateToken = (token: Keycloak.KeycloakInstance) => {
        console.log('AuthStore: udpdate Token: ', token);
        setToken(token);
        setAuthenticated(true);
        setChecked(true);
    };

    const tokenChecked = () => {
        setChecked(true);
    };

/*
    const updateRealm = (realm: string) => {
        console.log('AuthStore: update Realm', realm);
        setRealm(realm);
    };
*/
    return (
        <AuthContext.Provider value={{
            authenticated: (authenticated ? authenticated : false),
            token: token,
            updateToken: updateToken,
            checked: checked,
            updateChecked: tokenChecked
        }}>
            {props.children}
        </AuthContext.Provider>
    )
};

export const hasRole = (auth: any, role: string): boolean => {
    const roles: string[] = collectsRoles(APPLICATION, auth);
    return (roles.indexOf(role) > -1)
};


export interface TokenParsedBase {
    exp?: number;
    iat?: number;
    nonce?: string;
    sub?: string;
    session_state?: string;
    realm_access?: { roles: string[] };
    resource_access?: string[];
}

export interface ExtendedTokenParsed extends TokenParsedBase {
    name?: string;
    given_name?: string;
    preferred_username?: string;
    registrar?: string;
    registry?: boolean;
    customerId?: number;
    email?: string;
    registrarId?: number;
}

export const getUserFromToken = (auth: any) => {
    const parsed: ExtendedTokenParsed | undefined = auth.tokenParsed as ExtendedTokenParsed | undefined;
    return (parsed ? (parsed.name !== undefined ? parsed.name : parsed.preferred_username) : '');
};